
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import t from "@common/src/i18n/t";
const setting = namespace("setting");
const app = namespace("app");
const base = namespace("base");
@Component({})
export default class ManagementMode extends Vue {
  @setting.Action setOrderMode;
  @base.Action getSessionExtInfo;
  @app.State appType;
  modeFromData: any[] = [
    {
      code: "3",
      enable: false,
      inventory: "1",
      index: 0,
      assignTaskModeCode: "0"
    },
    {
      code: "1",
      enable: false,
      inventory: "2",
      index: 1,
      assignTaskModeCode: "0"
    }
  ];
  activeIndex: number = 0;
  currentIndex: number = 0;
  btnDisable: boolean = true;
  created() {
    this.setCurrentMode();
  }
  setCurrentMode() {
    this.getSessionExtInfo().then(data => {
      let activeData = this.modeFromData.find(item => {
        return item.code === data.data.orderModelCode;
      });
      activeData.enable = true;
      activeData.inventory = data.data.inventoryModelCode;
      activeData.assignTaskModeCode = data.data.assignTaskModeCode;
      this.currentIndex = activeData.index;
      this.activeIndex = activeData.index;
    });
  }
  modeFromRules: any = {
    inventory: [{ required: true, message: t("setting.select-management-mode"), trigger: "blur" }],
    assignTaskModeCode: [{ required: true, message: t("v210901.please-select-whether-open-dispatch"), trigger: "blur" }]
  };
  handleModeChange() {
    const enable = this.modeFromData.some(item => item.enable);
    enable ? (this.btnDisable = false) : (this.btnDisable = true);
  }
  handleEnableChange(value, index) {
    this.modeFromData.forEach(item => {
      item.enable = false;
    });
    this.modeFromData[index].enable = value;
    this.activeIndex = index;
    value ? (this.btnDisable = false) : (this.btnDisable = true);
  }

  submitForm() {
    this.setOrderMode({
      inventoryModelCode: this.modeFromData[this.activeIndex].inventory,
      orderModelCode: this.modeFromData[this.activeIndex].code,
      assignTaskModel: this.modeFromData[this.activeIndex].assignTaskModeCode
    })
      .then(
        () => {
          this.$message.success(t("setting.managed-mode-saved-successfully"));
          this.currentIndex = this.activeIndex;
        },
        () => {
          this.modeFromData[this.activeIndex].enable = false;
        }
      )
      .finally(() => {
        this.setCurrentMode();
      });
  }
}
